<section class="windows-cloud-hero">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="hero-content">
          <span class="hero-badge">
            <i class="bx bxl-windows"></i>
            Enterprise Windows Hosting
          </span>
          <h1 class="hero-title">
            Windows Cloud Infrastructure
          </h1>
          <p class="hero-description">
            Deploy powerful Windows Server instances with enterprise-grade performance, security, and scalability.
            Perfect for .NET applications, SQL Server databases, and Microsoft-based enterprise solutions.
          </p>

          <div class="pricing-highlight">
            <div class="pricing-content">
              <div class="price-tag">
                <span class="currency">₹</span>
                <span class="amount">1,499</span>
                <span class="period">/month</span>
              </div>
              <div class="pricing-details">
                <h4>All-inclusive Windows Cloud plans</h4>
                <p>
                  Full administrative access, automated backups, DDoS protection, and 99.9% uptime SLA included by default.
                </p>
              </div>
            </div>
          </div>

          <div class="hero-actions">
            <a routerLink="/contact" class="btn-primary-gradient">
              <i class="bx bx-phone"></i>
              Contact Us
            </a>
            <a routerLink="/contact" class="btn-outline-light">
              <i class="bx bx-phone"></i>
              Contact Sales
            </a>
          </div>

          <div class="hero-features">
            <div class="feature-item">
              <i class="bx bx-check-circle"></i>
              <span>99.9% uptime SLA guaranteed</span>
            </div>
            <div class="feature-item">
              <i class="bx bx-support"></i>
              <span>24/7 expert Windows engineers</span>
            </div>
            <div class="feature-item">
              <i class="bx bx-lock-alt"></i>
              <span>Full administrator and RDP access</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="hero-image">
          <div class="image-decoration">
            <img src="assets/img/windows-cloud-hero.png" alt="Windows Cloud Infrastructure" class="main-image" />

            <div class="floating-card card-1">
              <i class="bx bx-layer"></i>
              <span>Windows Server 2019/2022 Ready</span>
            </div>
            <div class="floating-card card-2">
              <i class="bx bx-data"></i>
              <span>SQL Server Optimized</span>
            </div>
            <div class="floating-card card-3">
              <i class="bx bx-shield-check"></i>
              <span>Enterprise Security</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="hero-background-elements">
    <div class="bg-element element-1"></div>
    <div class="bg-element element-2"></div>
    <div class="bg-element element-3"></div>
  </div>
</section>

<section class="features-section ptb-100">
  <div class="container">
    <div class="section-title">
      <span class="section-badge">Enterprise Features</span>
      <h2>Windows Cloud Capabilities</h2>
      <p>
        Enterprise-grade Windows Server instances with comprehensive features designed for mission-critical
        applications and business workloads.
      </p>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-6 mb-4">
        <div class="feature-card advanced">
          <div class="feature-header">
            <div class="feature-icon">
              <i class="bx bx-cog"></i>
            </div>
            <span class="feature-badge">Essential</span>
          </div>
          <h4>Full Administrative Access</h4>
          <p>
            Complete control over your Windows Server environment with administrator privileges,
            remote desktop access, and full customization capabilities.
          </p>
          <ul class="feature-list">
            <li>
              <i class="bx bx-check"></i>
              <span>Remote Desktop Protocol (RDP)</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Administrator privileges</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Custom software installation</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Registry and system modifications</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="feature-card advanced">
          <div class="feature-header">
            <div class="feature-icon">
              <i class="bx bx-tachometer"></i>
            </div>
            <span class="feature-badge">Performance</span>
          </div>
          <h4>High-Performance Infrastructure</h4>
          <p>
            NVMe SSD storage, high-speed networking, and latest-generation CPUs ensure optimal performance
            for demanding enterprise applications.
          </p>
          <ul class="feature-list">
            <li>
              <i class="bx bx-check"></i>
              <span>NVMe SSD storage</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Up to 10Gbps network</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Intel Xeon processors</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>ECC memory for reliability</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="feature-card advanced">
          <div class="feature-header">
            <div class="feature-icon">
              <i class="bx bx-shield-check"></i>
            </div>
            <span class="feature-badge">Security</span>
          </div>
          <h4>Enterprise Security</h4>
          <p>
            Multi-layered security with Windows Defender, advanced firewall, and enterprise-grade protection
            for your critical data.
          </p>
          <ul class="feature-list">
            <li>
              <i class="bx bx-check"></i>
              <span>Windows Defender Advanced</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Configurable firewall policies</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>SSL/TLS encryption</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Regular security updates</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="feature-card advanced">
          <div class="feature-header">
            <div class="feature-icon">
              <i class="bx bx-data"></i>
            </div>
            <span class="feature-badge">Backup</span>
          </div>
          <h4>Automated Backup Solutions</h4>
          <p>
            Comprehensive backup and disaster recovery with scheduled snapshots, point-in-time recovery,
            and geo-redundant storage.
          </p>
          <ul class="feature-list">
            <li>
              <i class="bx bx-check"></i>
              <span>Daily automated backups</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Instant snapshots</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Point-in-time recovery</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Geo-redundant storage</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="feature-card advanced">
          <div class="feature-header">
            <div class="feature-icon">
              <i class="bx bx-server"></i>
            </div>
            <span class="feature-badge">Database</span>
          </div>
          <h4>SQL Server Optimized</h4>
          <p>
            Pre-configured and optimized for Microsoft SQL Server with performance tuning, memory management,
            and storage optimization.
          </p>
          <ul class="feature-list">
            <li>
              <i class="bx bx-check"></i>
              <span>SQL Server 2019/2022 ready</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Performance optimization</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Memory configuration</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Storage best practices</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="feature-card advanced">
          <div class="feature-header">
            <div class="feature-icon">
              <i class="bx bx-trending-up"></i>
            </div>
            <span class="feature-badge">Scalability</span>
          </div>
          <h4>Dynamic Resource Scaling</h4>
          <p>
            Scale CPU, RAM, and storage resources on-demand without downtime to meet changing
            application requirements.
          </p>
          <ul class="feature-list">
            <li>
              <i class="bx bx-check"></i>
              <span>Vertical scaling</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Hot-add CPU/RAM</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Online storage expansion</span>
            </li>
            <li>
              <i class="bx bx-check"></i>
              <span>Load balancing options</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="windows-versions-section ptb-100">
  <div class="container">
    <div class="section-title">
      <span class="section-badge">Windows Server Editions</span>
      <h2>Choose Your Windows Server Version</h2>
      <p>
        Select from the latest Windows Server versions with full licensing included,
        each optimized for different workloads and enterprise requirements.
      </p>
    </div>

    <div class="row">
      <div class="col-lg-6 mb-4">
        <div class="version-card featured">
          <div class="version-header">
            <div class="version-icon">
              <i class="bx bxl-windows"></i>
            </div>
            <span class="version-badge latest">Latest</span>
          </div>
          <div class="version-content">
            <h3>Windows Server 2022</h3>
            <p class="version-description">
              The latest Windows Server with cutting-edge security, enhanced performance,
              and advanced hybrid cloud capabilities for modern enterprises.
            </p>

            <div class="version-highlights">
              <h5>Key Improvements:</h5>
              <ul class="highlight-list">
                <li>
                  <i class="bx bx-shield-check"></i>
                  <span>Enhanced security features</span>
                </li>
                <li>
                  <i class="bx bx-cloud"></i>
                  <span>Hybrid cloud integration</span>
                </li>
                <li>
                  <i class="bx bx-tachometer"></i>
                  <span>Improved performance</span>
                </li>
                <li>
                  <i class="bx bx-package"></i>
                  <span>Container support</span>
                </li>
                <li>
                  <i class="bx bx-network-chart"></i>
                  <span>Advanced networking</span>
                </li>
                <li>
                  <i class="bx bx-chip"></i>
                  <span>Hardware optimization</span>
                </li>
              </ul>
            </div>

            <div class="version-specs">
              <h5>Technical Specifications:</h5>
              <div class="spec-grid">
                <div class="spec-item">
                  <span class="spec-label">CPU Support</span>
                  <span class="spec-value">Up to 512 cores</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">RAM Support</span>
                  <span class="spec-value">Up to 48TB</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Storage</span>
                  <span class="spec-value">Storage Spaces Direct</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Containers</span>
                  <span class="spec-value">Windows &amp; Linux</span>
                </div>
              </div>
            </div>
          </div>
          <div class="version-footer">
            <a routerLink="/contact" class="btn-select-version">
              Select Windows Server 2022
            </a>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="version-card">
          <div class="version-header">
            <div class="version-icon">
              <i class="bx bxl-windows"></i>
            </div>
            <span class="version-badge stable">Stable</span>
          </div>
          <div class="version-content">
            <h3>Windows Server 2019</h3>
            <p class="version-description">
              Proven and reliable Windows Server version with extensive application support
              and enterprise-tested features for mission-critical workloads.
            </p>

            <div class="version-highlights">
              <h5>Key Features:</h5>
              <ul class="highlight-list">
                <li>
                  <i class="bx bx-check-circle"></i>
                  <span>Proven stability</span>
                </li>
                <li>
                  <i class="bx bx-support"></i>
                  <span>Wide application support</span>
                </li>
                <li>
                  <i class="bx bx-network-chart"></i>
                  <span>Advanced networking</span>
                </li>
                <li>
                  <i class="bx bx-data"></i>
                  <span>Storage improvements</span>
                </li>
                <li>
                  <i class="bx bx-shield"></i>
                  <span>Enhanced security</span>
                </li>
                <li>
                  <i class="bx bxl-windows"></i>
                  <span>Desktop experience</span>
                </li>
              </ul>
            </div>

            <div class="version-specs">
              <h5>Technical Specifications:</h5>
              <div class="spec-grid">
                <div class="spec-item">
                  <span class="spec-label">CPU Support</span>
                  <span class="spec-value">Up to 512 cores</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">RAM Support</span>
                  <span class="spec-value">Up to 24TB</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Storage</span>
                  <span class="spec-value">ReFS &amp; NTFS</span>
                </div>
                <div class="spec-item">
                  <span class="spec-label">Virtualization</span>
                  <span class="spec-value">Hyper-V ready</span>
                </div>
              </div>
            </div>
          </div>
          <div class="version-footer">
            <a routerLink="/contact" class="btn-select-version outline">
              Select Windows Server 2019
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="version-comparison">
      <h4>Version Comparison</h4>
      <div class="comparison-table-responsive">
        <table class="comparison-table">
          <thead>
            <tr>
              <th>Feature</th>
              <th>Windows Server 2022</th>
              <th>Windows Server 2019</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secured-core Server</td>
              <td class="text-success"><i class="bx bx-check"></i></td>
              <td class="text-muted"><i class="bx bx-x"></i></td>
            </tr>
            <tr>
              <td>Storage Migration Service</td>
              <td class="text-success"><i class="bx bx-check"></i></td>
              <td class="text-success"><i class="bx bx-check"></i></td>
            </tr>
            <tr>
              <td>Windows Admin Center</td>
              <td class="text-success"><i class="bx bx-check"></i></td>
              <td class="text-success"><i class="bx bx-check"></i></td>
            </tr>
            <tr>
              <td>Container Improvements</td>
              <td class="text-success"><i class="bx bx-check"></i></td>
              <td class="text-warning"><i class="bx bx-check-circle"></i></td>
            </tr>
            <tr>
              <td>Extended Support Until</td>
              <td><strong>2031</strong></td>
              <td><strong>2029</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</section>

<section class="use-cases-section">
  <div class="container">
    <div class="section-title">
      <span class="section-badge">Application Scenarios</span>
      <h2>Windows Cloud Use Cases</h2>
      <p>
        Discover how Windows Cloud infrastructure powers diverse business applications, from enterprise databases
        to modern web applications and development environments.
      </p>
    </div>

    <div class="row">
      <div class="col-lg-6 mb-4">
        <div class="use-case-card primary">
          <div class="use-case-header">
            <div class="use-case-icon">
              <i class="bx bx-data"></i>
            </div>
            <span class="use-case-category">Enterprise Database</span>
          </div>
          <h4>SQL Server &amp; Database Hosting</h4>
          <p>
            Deploy Microsoft SQL Server, MySQL, PostgreSQL, and other enterprise databases with optimized performance
            and high availability configurations.
          </p>
          <div class="use-case-features">
            <ul>
              <li>
                <i class="bx bx-check"></i>
                <span>SQL Server 2019/2022 support</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Always On Availability Groups</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Performance monitoring</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Automated backup solutions</span>
              </li>
            </ul>
          </div>
          <div class="use-case-stats">
            <div class="stat-item">
              <span class="stat-number">99.9%</span>
              <span class="stat-label">Uptime</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">&lt; 1ms</span>
              <span class="stat-label">Latency</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="use-case-card secondary">
          <div class="use-case-header">
            <div class="use-case-icon">
              <i class="bx bx-code-alt"></i>
            </div>
            <span class="use-case-category">Web Development</span>
          </div>
          <h4>ASP.NET &amp; Web Applications</h4>
          <p>
            Host ASP.NET, .NET Core, and other Windows-based web applications with IIS, advanced caching,
            and load balancing capabilities.
          </p>
          <div class="use-case-features">
            <ul>
              <li>
                <i class="bx bx-check"></i>
                <span>IIS 10 with .NET Framework</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>.NET Core 6/7 support</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Application pool isolation</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>SSL/TLS encryption</span>
              </li>
            </ul>
          </div>
          <div class="use-case-stats">
            <div class="stat-item">
              <span class="stat-number">10Gbps</span>
              <span class="stat-label">Network</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">CDN</span>
              <span class="stat-label">Ready</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="use-case-card tertiary">
          <div class="use-case-header">
            <div class="use-case-icon">
              <i class="bx bx-building"></i>
            </div>
            <span class="use-case-category">Enterprise Software</span>
          </div>
          <h4>Business Applications</h4>
          <p>
            Deploy enterprise applications like SharePoint, Exchange Server, Active Directory, and custom business
            software with enterprise-grade reliability.
          </p>
          <div class="use-case-features">
            <ul>
              <li>
                <i class="bx bx-check"></i>
                <span>SharePoint Server 2019/2022</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Exchange Server support</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Active Directory integration</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Custom LOB applications</span>
              </li>
            </ul>
          </div>
          <div class="use-case-stats">
            <div class="stat-item">
              <span class="stat-number">24/7</span>
              <span class="stat-label">Support</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">SLA</span>
              <span class="stat-label">Guaranteed</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 mb-4">
        <div class="use-case-card quaternary">
          <div class="use-case-header">
            <div class="use-case-icon">
              <i class="bx bx-code-block"></i>
            </div>
            <span class="use-case-category">Development Environment</span>
          </div>
          <h4>Development &amp; Testing</h4>
          <p>
            Set up comprehensive development environments with Visual Studio, .NET SDK, testing frameworks,
            and CI/CD pipeline tools.
          </p>
          <div class="use-case-features">
            <ul>
              <li>
                <i class="bx bx-check"></i>
                <span>Visual Studio Enterprise</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Azure DevOps integration</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Docker container support</span>
              </li>
              <li>
                <i class="bx bx-check"></i>
                <span>Testing automation tools</span>
              </li>
            </ul>
          </div>
          <div class="use-case-stats">
            <div class="stat-item">
              <span class="stat-number">Git</span>
              <span class="stat-label">Ready</span>
            </div>
            <div class="stat-item">
              <span class="stat-number">CI/CD</span>
              <span class="stat-label">Pipeline</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="additional-use-cases">
      <h4>Additional Use Cases</h4>
      <div class="row">
        <div class="col-md-3 col-sm-6 mb-4">
          <div class="mini-use-case">
            <i class="bx bx-desktop"></i>
            <h6>Remote Desktop Services</h6>
            <p>Virtual desktop infrastructure for remote work</p>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 mb-4">
          <div class="mini-use-case">
            <i class="bx bx-file"></i>
            <h6>File &amp; Print Services</h6>
            <p>Centralized file storage and document management</p>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 mb-4">
          <div class="mini-use-case">
            <i class="bx bx-game"></i>
            <h6>Game Server Hosting</h6>
            <p>Windows-based game servers and gaming applications</p>
          </div>
        </div>

        <div class="col-md-3 col-sm-6 mb-4">
          <div class="mini-use-case">
            <i class="bx bx-analyse"></i>
            <h6>Business Intelligence</h6>
            <p>SQL Server Analysis Services and reporting</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="cta-section">
  <div class="container">
    <div class="cta-content-wrapper">
      <div class="row align-items-center">
        <div class="col-lg-8">
          <div class="cta-content">
            <h2>Ready to Deploy Windows Cloud Infrastructure?</h2>
            <p class="cta-description">
              Launch your Windows Server instance in minutes with full administrative access,
              enterprise features, and 24/7 expert support. Start your digital transformation today.
            </p>

            <div class="cta-features">
              <div class="feature-item">
                <i class="bx bx-rocket"></i>
                <span>Deploy in under 60 seconds</span>
              </div>
              <div class="feature-item">
                <i class="bx bx-support"></i>
                <span>24/7 Windows-certified engineers</span>
              </div>
              <div class="feature-item">
                <i class="bx bx-money"></i>
                <span>Transparent, pay-as-you-use pricing</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-4">
          <div class="cta-actions">
            <a routerLink="/contact" class="btn-cta-primary">
              <i class="bx bx-rocket"></i>
              <span>Launch Windows Cloud</span>
              <small>Start your free trial</small>
            </a>

            <a routerLink="/contact" class="btn-cta-secondary">
              <i class="bx bx-phone"></i>
              <span>Contact Sales Team</span>
              <small>Get custom pricing</small>
            </a>

            <div class="cta-guarantee">
              <i class="bx bx-shield-check"></i>
              <span>99.9% Uptime SLA Guaranteed</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
